// Close icon that follows the cursor over a drawer overlay (md+). Shared by every drawer:
// the icon centres on the pointer while over the overlay and fades out in place when the
// cursor enters the panel. The overlay itself handles the click-to-close; the icon is
// pointer-events-none so the click falls through to it.
export function initCursorFollowClose(
  overlay: HTMLElement | null,
  follow: HTMLElement | null
) {
  const isMd = window.matchMedia('(min-width: 1024px)');
  let rafId = 0;

  const onMove = (event: MouseEvent) => {
    if (!follow || !isMd.matches) return;
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      // Centre the icon on the cursor (translate % is relative to the icon's own size).
      follow.style.transform =
        `translate(calc(-50% + ${event.clientX}px), calc(-50% + ${event.clientY}px))`;
      follow.classList.remove('opacity-0');
    });
  };

  const hide = () => {
    cancelAnimationFrame(rafId);
    follow?.classList.add('opacity-0');
  };

  overlay?.addEventListener('mousemove', onMove);
  overlay?.addEventListener('mouseleave', hide);

  return {
    hide,
    destroy() {
      overlay?.removeEventListener('mousemove', onMove);
      overlay?.removeEventListener('mouseleave', hide);
      cancelAnimationFrame(rafId);
    },
  };
}
